<div mat-dialog-title appDraggableDialog draggableKey="header-color" dialogClass=".q9-header-color">
  <span>{{ 'POPUPS.LEGEND_CHANGE_BACKGROUND' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="header-color">
  <div class="header-color--palette">
    <span>{{ 'POPUPS.CHOOSE_COLOR_LABEL' | translate }}</span>
    <input
      type="color"
      #colorPicker
      (input)="colorSelected($event)"
      (change)="finishedSelecting($event)"
      [value]="currentSelectedColor"
      class="header-color--palette__picker" />
    <div
      (click)="openPalette(colorPicker)"
      class="header-color--palette__preview header-color-field"
      [ngStyle]="{
        'background-color': (sfaHeaderSvc.previewColor$ | async) || currentSelectedColor
      }">
      <p [ngStyle]="{color: (fontColor$ | async) || defaultColor}">
        {{ 'POPUPS.CLICK_HERE_LABEL' | translate }}
      </p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="header-color--preset header-color-field">
    <div class="header-color--preset__container">
      <span>{{ 'POPUPS.PREVIOUS_COLOR_LABEL' | translate }}</span>
      <div
        class="header-color--preset__canvas"
        (mouseenter)="previewPreviousColor()"
        (mouseleave)="cancelPreview()"
        (click)="selectFromOptions(previousColor)"
        [ngStyle]="{'background-color': previousColor}">
        <p [ngStyle]="{color: previousFontColor}">
          {{ 'POPUPS.HOVER_OR_CLICK_LABEL' | translate }}
        </p>
      </div>
    </div>
    <div class="header-color--preset__container">
      <span>{{ 'POPUPS.DEFAULT_COLOR_LABEL' | translate }}</span>
      <div
        class="header-color--preset__canvas"
        (mouseenter)="previewDefaultColor()"
        (mouseleave)="cancelPreview()"
        (click)="selectFromOptions(defaultColor)"
        [ngStyle]="{'background-color': defaultColor}">
        <p [ngStyle]="{color: defaultFontColor}">{{ 'POPUPS.HOVER_OR_CLICK_LABEL' | translate }}</p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="applyColor()">
    {{ 'POPUPS.APPLY_LABEL' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
